@use '../../styles/global' as *;

@layer kol-component {
	.kol-headline {
		&--secondary {
			margin: 0;
		}
	}
}
